import logo from "assets/images/logo-blue.png";
import { ParagraphSizes } from "atoms/constants/paragraph-sizes";
import Paragraph from "atoms/typography/paragraph";
import { UnicodeCharacterConstants } from "constants/unicode-character-constants";
import moment from "moment";
import React, { HTMLAttributes, PropsWithChildren } from "react";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface DemoPrintFooterProps extends HTMLAttributes<HTMLDivElement> {}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const BASE_CLASS = "c-printable__demoFooter";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const DemoPrintFooter: React.FC<PropsWithChildren<DemoPrintFooterProps>> = (
    props: PropsWithChildren<DemoPrintFooterProps>
) => {
    return (
        <div className={BASE_CLASS}>
            <img src={logo} alt="Home" />

            <Paragraph
                cssClassName={`${BASE_CLASS}__copyright`}
                size={ParagraphSizes.XSmall}>
                {UnicodeCharacterConstants.Copyright} National Fire Protection
                Association (NFPA) {moment().year()}
            </Paragraph>
        </div>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default DemoPrintFooter;

// #endregion Exports
